import { render } from "./DataGrid.vue?vue&type=template&id=bfc74eae"
import script from "./DataGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./DataGrid.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Landingpage/DataGrid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bfc74eae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bfc74eae', __exports__)) {
    api.reload('bfc74eae', __exports__)
  }
  
  module.hot.accept("./DataGrid.vue?vue&type=template&id=bfc74eae", () => {
    api.rerender('bfc74eae', render)
  })

}


export default __exports__